import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import UnresolvedTicktsChart from './UnresolvedTicktsChart';
import PropTypes from 'prop-types';
import { getDashboardPriority } from 'functions/dashboard';
import moment from 'moment';

const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
  
  <div className="position-relative">
    <Form.Control
      size="sm"
      ref={ref}
      onClick={onClick}
      value={value}
      className="ps-4"
      onChange={e => {
        console.log({ e });
      }}
    />
    <FontAwesomeIcon
      icon="calendar-alt"
      className="text-primary position-absolute top-50 translate-middle-y ms-2"
    />
  </div>
));

const UnresolvedTickets = ({fromDate, toDate}) => {

  const chartRef = useRef(null);
  const handleLegend = (event, name) => {
    chartRef.current.getEchartsInstance().dispatchAction({
      type: 'legendToggleSelect',
      name: name
    });
  };

  // Initialize state variables with initial values of 0
  const [week_PriorityLowTotal, setWeek_PriorityLowTotal] = useState(0);
  const [week_PriorityMediumTotal, setWeek_PriorityMediumTotal] = useState(0);
  const [week_PriorityHighTotal, setWeek_PriorityHighTotal] = useState(0);
  const [week_PriorityUrgentTotal, setWeek_PriorityUrgentTotal] = useState(0);
  const [week_PriorityEmergencyTotal, setWeek_PriorityEmergencyTotal] = useState(0);


  const [date,setDate]=useState(new Date());

   const [data,setData] =useState([null
    // [20, 18, 15, 20, 12, 15, 10],
    // [30, 20, 20, 25, 20, 15, 10],
    // [35, 32, 40, 50, 30, 25, 15],
    // [15, 25, 20, 18, 10, 15, 25]
  ]);

  useEffect(()=>{
    loadData();
  },[date])

  const loadData=async()=>{

    const token = localStorage.getItem('token');
    // console.log('getDashboardPriority token :',token);
    let _date=moment(date).format('yyyy-MM-DD');
    const results = await getDashboardPriority(_date, token);
    console.log('date.toString(yyyy-mm-dd) :',_date);
    console.log('getDashboardPriority',results);
    const week_PriorityLow = [];
    const week_PriorityMedium = [];
    const week_PriorityHigh = [];
    const week_PriorityUrgent = [];
    const week_PriorityEmergency = [];

    if(results){
    for (let i = 0; i < results.length; i++) {
      //priority low
      const priorityLow = results[i].filter(o => o.PriorityId === 1);
      week_PriorityLow.push(priorityLow[0].count);

      //priority medium
      const priorityMedium = results[i].filter(o => o.PriorityId === 2);
      week_PriorityMedium.push(priorityMedium[0].count);

      //priority High
      const priorityHigh = results[i].filter(o => o.PriorityId === 3);
      week_PriorityHigh.push(priorityHigh[0].count);

      //priority Urgent
      const priorityUrgent = results[i].filter(o => o.PriorityId === 4);
      week_PriorityUrgent.push(priorityUrgent[0].count);

      //priority Emergency
      const priorityEmergency = results[i].filter(o => o.PriorityId === 5);
      week_PriorityEmergency.push(priorityEmergency[0].count);
    }
  }

    setData([
      week_PriorityEmergency,
      week_PriorityUrgent,
      week_PriorityHigh,
      week_PriorityMedium,
      week_PriorityLow
    ]);
    console.log('week_PriorityLow', week_PriorityLow);
    console.log('week_PriorityMedium', week_PriorityMedium);
    console.log('week_PriorityHigh', week_PriorityHigh);
    console.log('week_PriorityUrgent', week_PriorityUrgent);
    console.log('week_PriorityEmergency', week_PriorityEmergency);

    let week_PriorityLowTotal = 0;
    let week_PriorityMediumoTotal = 0;
    let week_PriorityHighTotal = 0;
    let week_PriorityUrgenTotal = 0;
    let week_PriorityEmergencyTotal = 0;

    //week_PriorityLowTotal
    for (let i = 0; i < week_PriorityLow.length; i++) {
      week_PriorityLowTotal += week_PriorityLow[i];
    }

    //week_PriorityMediumoTotal
    for (let i = 0; i < week_PriorityMedium.length; i++) {
      week_PriorityMediumoTotal += week_PriorityMedium[i];
    }

    //week_PriorityHighTotal
    for (let i = 0; i < week_PriorityHigh.length; i++) {
      week_PriorityHighTotal += week_PriorityHigh[i];
    }

    //week_PriorityUrgenTotal
    for (let i = 0; i < week_PriorityUrgent.length; i++) {
      week_PriorityUrgenTotal += week_PriorityUrgent[i];
    }

    //week_PriorityEmergencyTotal
    for (let i = 0; i < week_PriorityEmergency.length; i++) {
      week_PriorityEmergencyTotal += week_PriorityEmergency[i];
    }

    setWeek_PriorityLowTotal(week_PriorityLowTotal);
    setWeek_PriorityMediumTotal(week_PriorityMediumoTotal);
    setWeek_PriorityHighTotal(week_PriorityHighTotal);
    setWeek_PriorityUrgentTotal(week_PriorityUrgenTotal);
    setWeek_PriorityEmergencyTotal(week_PriorityEmergencyTotal);

  }


  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Unresolved Tickets by Priority"
        titleTag="h6"
        className="border-200 border-bottom py-2"
        endEl={
          <div className='d-flex ' style={{paddingTop:'14px' }}>
             <Form.Group
            as={Row}
            className="mb-3"
            controlId="formPlaintextPriority"
          >
              <div style={{ display: 'flex' }}>
              <Form.Label column sm="3" style={{fontSize:'14px'}}>
              Day of the Week
            </Form.Label>
                <div
                  style={{
                    marginRight: '10px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <DatePicker
                    selected={date}
                    onChange={date => {
                      setDate(date);
                    }}
                    dateFormat="MMM d, yyyy"
                    customInput={<GreetingsDateInput />}
                  />
                </div>
              </div>
            
          </Form.Group>
          <CardDropdown />
          </div>
     
      }
      />
      <Card.Body className="py-0">
        <Row>
          <Col
            md="auto"
            className="border-md-end border-md-200 pt-3 pt-md-0 d-md-flex align-items-center"
          >
            <Row className="flex-md-column px-3">
              <Col
                xs="auto"
                className="border-end border-md-end-0 border-md-bottom pb-md-3 mb-md-3 ps-0 ps-md-3 pe-x1 pe-md-3 me-1 me-md-0"
              >
                <div className="d-flex align-items-center mb-n1">
                  <Form.Check.Label
                    htmlFor="emergency"
                    className="fs-0 mb-n1 text-700 cursor-pointer "
                  >
                  {week_PriorityEmergencyTotal}
                  </Form.Check.Label>
                  <Form.Check.Input
                    onChange={event => handleLegend(event, 'Emergency')}
                    type="checkbox"
                    id="emergency"
                    defaultChecked
                    className="small-dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer"
                    style={{backgroundColor:'red'}}
                  />
                </div>
                <Form.Check.Label
                  htmlFor="emergency"
                  className="fs--2 mb-0 text-700 cursor-pointer"
                >
                  Emerge.
                </Form.Check.Label>
              </Col>
              <Col
                xs="auto"
                className="border-end border-md-end-0 border-md-bottom pb-md-3 mb-md-3 ps-0 ps-md-3 pe-x1 pe-md-3 me-1 me-md-0"
              >
                <div className="d-flex align-items-center mb-n1">
                  <Form.Check.Label
                    htmlFor="urgent"
                    className="fs-0 mb-n1 text-700 cursor-pointer "
                  >
                    {week_PriorityUrgentTotal}
                  </Form.Check.Label>
                  <Form.Check.Input
                    onChange={event => handleLegend(event, 'Urgent')}
                    type="checkbox"
                    id="urgent"
                    defaultChecked
                    className="small-dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer"
                  />
                </div>
                <Form.Check.Label
                  htmlFor="urgent"
                  className="fs--2 mb-0 text-700 cursor-pointer"
                >
                  Urgent
                </Form.Check.Label>
              </Col>
              <Col
                xs="auto"
                className="border-end border-md-end-0 border-md-bottom pb-md-3 mb-md-3 pe-x1 pe-md-3 me-1 me-md-0"
              >
                <div className="d-flex align-items-center mb-n1">
                  <Form.Check.Label
                    htmlFor="high"
                    className="fs-0 mb-n1 text-700 cursor-pointer "
                  >
                   {week_PriorityHighTotal}
                  </Form.Check.Label>
                  <Form.Check.Input
                    onChange={event => handleLegend(event, 'High')}
                    type="checkbox"
                    id="high"
                    defaultChecked
                    className="small-dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer form-check-input-info"
                  />
                </div>
                <Form.Check.Label
                  htmlFor="high"
                  className="fs--2 mb-0 text-700 cursor-pointer"
                >
                  High
                </Form.Check.Label>
              </Col>
              <Col
                xs="auto"
                className="border-end border-md-end-0 border-md-bottom pb-md-3 mb-md-3 pe-x1 pe-md-3 me-1 me-md-0"
              >
                <div className="d-flex align-items-center mb-n1">
                  <Form.Check.Label
                    htmlFor="medium"
                    className="fs-0 mb-n1 text-700 cursor-pointer "
                  >
                {week_PriorityMediumTotal}
                  </Form.Check.Label>
                  <Form.Check.Input
                    onChange={event => handleLegend(event, 'Medium')}
                    type="checkbox"
                    id="medium"
                    defaultChecked
                    className="small-dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer bg-priority-medium"
                  />
                </div>
                <Form.Check.Label
                  htmlFor="medium"
                  className="fs--2 mb-0 text-700 cursor-pointer"
                >
                  Medium
                </Form.Check.Label>
              </Col>

              <Col xs="auto" className="pe-0">
                <div className="d-flex align-items-center mb-n1">
                  <Form.Check.Label
                    htmlFor="low"
                    className="fs-0 mb-n1 text-700 cursor-pointer "
                  >
                 {week_PriorityLowTotal}
                  </Form.Check.Label>
                  <Form.Check.Input
                    onChange={event => handleLegend(event, 'Low')}
                    type="checkbox"
                    id="low"
                    defaultChecked
                    className="small-dot mt-0 shadow-none remove-checked-icon rounded-circle cursor-pointer bg-priority-low"
                  />
                </div>
                <Form.Check.Label
                  htmlFor="low"
                  className="fs--2 mb-0 text-700 cursor-pointer"
                >
                  Low
                </Form.Check.Label>
              </Col>
            </Row>
          </Col>
          <Col md="auto" className="echart-unresolved-tickets-container">
            <UnresolvedTicktsChart data={data} ref={chartRef} />
          </Col>
        </Row>
      </Card.Body>
      {/* <Card.Footer className="text-center border-top border-200 p-0">
        <a href="#!" className="btn btn-link btn-sm px-0 fw-medium py-2">
          View all
          <FontAwesomeIcon icon="chevron-right" className="ms-1 fs--2" />
        </a>
      </Card.Footer> */}
    </Card>
  );
};

UnresolvedTickets.propTypes = {
  data: PropTypes.array.isRequired
};

export default UnresolvedTickets;
